// theme.js
    //blue: '#4ec1e0',
export default {
  colors: {
    blue: '#4ec1e0',
    black: '#404040',
    lightblue: '#e9f6f8',
    darkwhite: '#fafafa',
    lightgrey: '#c6c6c6',
    mediumgrey: '#f0f0f0',
    darkgrey: '#a5a5a5',
    white: 'white',
    red: '#e34c46',
    green: '#76b376',
    orange: '#f6934b',
    pink: '#f64b7f'
  },
  FontSize: {
      normal: '16px',
  }
}



// WEBPACK FOOTER //
// src/theme.js